import { render } from "./JourneySetGroups.vue?vue&type=template&id=62654120&scoped=true"
import script from "./JourneySetGroups.vue?vue&type=script&lang=ts"
export * from "./JourneySetGroups.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-62654120"

export default script